export default "__VITE_ASSET__BOsvR8Fa__"